import { getTheme } from 'Utilities/themeHelpers';
import { NAVIGATION } from '../nav/types';
import { SET_ENV } from './types';
const initialState = {
  osType: 'none',
  osVersion: 'none',
  appVersion: 'none',
  deviceId: '',
  theme: getTheme(new URLSearchParams(window.location.search)),
  app: 'libre1',
  deviceManufacturer: 'none',
  deviceModel: 'none',
  country: 'US',
  pId: '',
  pName: '',
  state: 'success'
};
export const envReducer = (state = initialState, action) => {
  switch (action.type) {
    case NAVIGATION:
      return {
        ...state,
        app: action.context.query?.app || state.app,
        country: action.context.query?.country || state.country,
        pId: action.context.query?.pId || state.pId,
        osType: action.context.query?.osType || state.osType,
        osVersion: action.context.query?.osVersion || state.osVersion,
        deviceId: action.context.query?.deviceId || state.deviceId,
        appVersion: action.context.query?.appVersion || state.appVersion,
        state: action.context.query?.state || state.state,
        pName: action.context.query?.pName || state.pName,
        isTestEnvironment: action.context.query?.isTestEnvironment ? Boolean(action.context.query.isTestEnvironment) : state.isTestEnvironment
      };
    case SET_ENV:
      return {
        ...state,
        ...action.env
      };
    default:
      return state;
  }
};